// extracted by mini-css-extract-plugin
module.exports = {"BoxplotFactorChart":"BoxplotFactorChart_BoxplotFactorChart__2G8Xx"};